import __base_store from '@/store/__base_store'

/**
 * Store de descuentos (modelo `discount`) construido desde el factory común.
 */
export default __base_store({
	/** Estado propio del modelo `discount`. */
	state: {
		model_name: 'discount',
	},
})

